export default function AcceptSvg({ width, height, style = "" }) {
  return (
    <svg
      className={`${style}`}
      width={width}
      height={height}
      viewBox='0 0 24 24'
      fill='#FFF'
      xmlns='http://www.w3.org/2000/svg'
    >
        <path
          style={{ fillRule: "evenodd" }}
          id='checkmark'
          d='M1224,312a12,12,0,1,1,3.32-23.526l-1.08,1.788A10,10,0,1,0,1234,300a9.818,9.818,0,0,0-.59-3.353l1.27-2.108A11.992,11.992,0,0,1,1224,312Zm0.92-8.631a0.925,0.925,0,0,1-.22.355,0.889,0.889,0,0,1-.72.259,0.913,0.913,0,0,1-.94-0.655l-3.82-3.818a0.9,0.9,0,0,1,1.27-1.271l3.25,3.251,7.39-10.974a1,1,0,0,1,1.38-.385,1.051,1.051,0,0,1,.36,1.417Z'
          transform='translate(-1212 -288)'
        />
    </svg>
  );
}